var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnCancelLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 49,
    viewBox: "0 0 104 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_791_63928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8107 16.5H61.0825C61.3258 16.5 61.5592 16.5937 61.7313 16.7603C61.9033 16.927 62 17.1531 62 17.3889V31.6111C62 31.8469 61.9033 32.073 61.7313 32.2397C61.5592 32.4064 61.3258 32.5 61.0825 32.5H47.8107C47.6597 32.5 47.511 32.4639 47.3779 32.3949C47.2447 32.3259 47.1312 32.2261 47.0474 32.1044L42.1543 24.9933C42.0537 24.8473 42 24.6756 42 24.5C42 24.3244 42.0537 24.1527 42.1543 24.0067L47.0474 16.8956C47.1312 16.7739 47.2447 16.6741 47.3779 16.6051C47.511 16.5361 47.6597 16.5 47.8107 16.5ZM48.3016 18.2778L44.0205 24.5L48.3016 30.7222H60.165V18.2778H48.3016ZM53.7424 23.2431L56.3371 20.7284L57.6354 21.9862L55.0398 24.5L57.6354 27.0138L56.3371 28.2716L53.7424 25.7569L51.1477 28.2716L49.8494 27.0138L52.4451 24.5L49.8494 21.9862L51.1477 20.7284L53.7424 23.2431Z",
    fill: "#363736"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_791_63928",
    x: -5,
    y: -4.5,
    width: 114,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_791_63928"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_63928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_63928",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCancelLogin);
export default __webpack_public_path__ + "static/media/btn-cancel-login.0b78820cdfd50f12a64430cc154edcab.svg";
export { ForwardRef as ReactComponent };